// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import ratios from 'Components/utils/ratios/ratios.utils.js';
import { truncate } from 'Components/utils/string/string.util';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { ProductIntroductionActions } from 'Components/widgets/product-introduction-actions/ProductIntroductionActions.jsx';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

type Props = {
  className?: string,
  communityLabel?: string,
  iconName: IconName,
  imageSrc?: string,
  ratingImage?: ?{
    alt: string,
    src: string,
  },
  reduceLabel?: string,
  seasonLink: ?{
    iconName?: IconName,
    label: string,
    url: string,
  },
  seeMoreLabel?: string,
  text?: string,
  title?: string,
};

export function ProductIntroductionExclusiveCollection(props: Props) {
  const {
    className,
    communityLabel,
    iconName,
    imageSrc,
    ratingImage,
    reduceLabel,
    seasonLink,
    seeMoreLabel,
    text,
    title,
  } = props;

  if (!title) return null;

  return (
    <article className={classnames(className)}>
      <ProductIntroductionActions
        className="my-5"
        communityLabel={communityLabel}
        ratingImage={ratingImage}
        seasonLink={seasonLink}
      />
      <div className="flex">
        <div className="hidden md:block h-full image-responsive-cell inset-border-after mb-15 sm:mb-0 sm:rtl:mr-5 sm:w-2/5">
          <Image imageUrl={imageSrc} ratioKey={ratios.R_65_BY_48} />
        </div>
        <div className="text-center md:w-3/5 lg:px-24 lg:pt-16">
          <Icon
            className="border-5 border-deepBlue p-2 mb-9 lg:mb-15"
            color={COLORS.DEEP_BLUE}
            isNotSquare
            name={iconName}
            width="8.875rem"
          />
          <Title theme="title-serif-1">{truncate(title, 50)}</Title>
          <TextSeeMore
            className="mt-9 lg:mt-15"
            hasNoScrollOnCollapse
            isCollapseEnabled
            seeLessLabel={reduceLabel}
            seeMoreLabel={seeMoreLabel}
            seeMoreSize={110}
            text={text}
            theme="text-sans-3"
          />
        </div>
      </div>
    </article>
  );
}
